import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import {
  resetPaciente,
  wsPostActualizarClave,
} from "../../context/Actions/paciente/paciente";
import { login, logoutAuth } from "../../../global/context/action/auth/login";
import { useHistory } from "react-router";
import { regexNumero } from "../../../global/utils/expresionesRegulares";
import { showModal, hideModal } from "../../context/Actions/modal/modal";
import { logoutPacienteDefault } from "../../context/Actions/paciente/paciente";
import Modal from "../../components/Genericos/Modal/Modal";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import sliceInput from "../../../global/utils/sliceInput";
import "./LoginStyle.css";
import { tokenLoginLogout } from "../../context/Actions/token/logoutToken";
import HidePassIcon from "../../assets/images/generico/HidePassIcon";
import ShowPassIcon from "../../assets/images/generico/ShowPassIcon";
import { GlobalContext } from "../../../global/context/Provider";
import InputV1 from "../../components/Genericos/InputV1/InputV1";

const LoginToken = () => {
  const {
    tokenState,
    pacienteState,
    modalDispatch,
    pacienteDispatch,
    modalState,
    tokenDispatch,
  } = useContext(PortalContext);

  // Nuevo contexto
  const {
    authState,
    authDispatch,
    toasterDispatch,
    toasterState,
    configState,
  } = useContext(GlobalContext);

  const history = useHistory();
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errorNewPassword, setErrorNewPasssord] = useState(false);
  const [errorRepeatPassword, setErrorRepeatPassword] = useState(false);
  const [habilitaBtn, setHabilitaBtn] = useState(false);
  const [flgLogin, setFlgLogin] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownRepeat, setPasswordShownRepeat] = useState(false);
  const widthWindow = window.innerWidth;

  const showPassword = () => {
    setPasswordShown(true);
  };
  const hidePassword = () => {
    setPasswordShown(false);
  };

  const showPasswordRepeat = () => {
    setPasswordShownRepeat(true);
  };
  const hidePasswordRepeat = () => {
    setPasswordShownRepeat(false);
  };

  const onKeyPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
      // Mostrar mensaje amigable cada vez que intenten ingresar letras
      showToaster(
        {
          texto:
            "La contraseña debe contener solo números. Por favor, ingrese únicamente dígitos del 0 al 9.",
          tipo: "info",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    if (e.target.name === "txtNewPassword") {
      if (e.key === "Enter") {
        document.getElementsByName("txtRepeatPassword")[0].focus();
      }
    }
    if (e.target.name === "txtRepeatPassword") {
      if (e.key === "Enter") {
        onGenerarContraseña();
      }
    }
  };
  const isPasswordValido = (e) => {
    if (e.target.value.length < 4) {
      return true;
    }
    if (e.target.value.length >= 4) {
      return false;
    }
    if (e.target.value === "") {
      return true;
    }
    return false;
  };

  const onNewPasswordChange = (e) => {
    sliceInput(e);
    setNewPassword(e.target.value);
    setErrorNewPasssord(isPasswordValido(e));
  };
  const onRepeatPasswordChange = (e) => {
    sliceInput(e);
    setRepeatPassword(e.target.value);
    setErrorRepeatPassword(isPasswordValido(e));
  };

  const onGenerarContraseña = () => {
    if (newPassword === repeatPassword) {
      wsPostActualizarClave(newPassword, repeatPassword, 0)(pacienteDispatch);
    } else {
      showToaster(
        {
          texto:
            "Las contraseñas no coinciden. Ingresá nuevamente su contraseña.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const ingresaPortal = () => {
    hideModal()(modalDispatch);
    logoutPacienteDefault()(pacienteDispatch);
    tokenLoginLogout()(tokenDispatch);
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/consultamedica");
    }
  };

  useEffect(() => {
    if (
      pacienteState.paciente.cambioClave !== null &&
      pacienteState.paciente.cambioClave !== undefined &&
      pacienteState.paciente.cambioClave.origen === "cambioClave"
    ) {
      let dto = {
        txtDni: pacienteState.paciente.cambioClave.paciente.nroDocumento,
        txtPassword: repeatPassword,
      };
      setFlgLogin(true);
      login(dto, configState.config.data.sectorTurno)(authDispatch);
    } else if (
      pacienteState.paciente.error !== null &&
      pacienteState.paciente.error !== undefined &&
      pacienteState.paciente.error !== false &&
      pacienteState.paciente.error.origen === "cambioClave"
    ) {
      showToaster(
        {
          texto: pacienteState.paciente.error,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      resetPaciente()(pacienteDispatch);
    }
  }, [pacienteState]);

  useEffect(() => {
    if (
      authState.auth.data !== null &&
      authState.auth.data !== undefined &&
      flgLogin
    ) {
      if (authState.auth.data && sessionStorage.token && flgLogin) {
        resetPaciente()(pacienteDispatch);
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Contraseña generada exitosamente!",

            texto: "Ahora puede ingresar al Portal, utilizando su contraseña.",

            dissmiss: dissmiss,
          },
          [
            {
              text: "Ingresar al portal",
              clase: "btn-Mensaje-1 rb16m bgc-primary c-white",
              accion: ingresaPortal,
            },
          ],
          "centro"
        )(modalDispatch);
      }
    } else if (
      authState.auth.error !== null &&
      authState.auth.error !== undefined &&
      authState.auth.error !== false
    ) {
      showToaster(
        {
          texto: authState.auth.error.detail,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      resetPaciente()(pacienteDispatch);
      logoutAuth()(authDispatch);
    }
  }, [authState.auth]);

  useEffect(() => {
    if (errorNewPassword || errorRepeatPassword) {
      setHabilitaBtn(false);
    }
    if (
      !errorNewPassword &&
      !errorRepeatPassword &&
      newPassword !== "" &&
      repeatPassword !== ""
    ) {
      setHabilitaBtn(true);
    }
  }, [errorRepeatPassword, errorNewPassword, newPassword, repeatPassword]);

  return (
    <div className="ptur-loginToken">
      {toasterState.toaster.show && <ToasterV2 />}
      {modalState.modal.show && <Modal />}
      {/* <img
        className="ptur-loginToken-logoImg"
        src={IsoLogo}
        alt="DIM LOGO"
      ></img> */}
      <img
        className="ptur-loginLeftPanel-logo"
        src={process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"}
        alt="logo"
      ></img>
      <div className="ptur-loginToken-titleBox">
        <span className="c-white rb24b">Crear una contraseña nueva</span>
      </div>
      <div className="ptur-loginToken-box">
        <div className="ptur-loginToken-box-input">
          <InputV1
            name="txtNewPassword"
            inputType="number"
            headerStr="Ingresa tu Contraseña"
            errorStr="La contraseña no es válida"
            className={
              passwordShown
                ? "inputNumericShow inputNonScroll rb16m"
                : "inputNumeric inputNonScroll rb16m"
            }
            maxLength="10"
            checkError={errorNewPassword}
            isRequired={true}
            onKeyPress={onKeyPress}
            onChange={onNewPasswordChange}
            value={newPassword}
          />
          {passwordShown === false ? (
            <>
              <button
                className="ptur-loginToken-show-hideBtn"
                onClick={() => showPassword()}
              >
                <HidePassIcon color="var(--color-latex30)" />
              </button>
            </>
          ) : (
            <>
              <button
                className="ptur-loginToken-show-hideBtn"
                onClick={() => hidePassword()}
              >
                <ShowPassIcon color="var(--color-latex30)" />
              </button>
            </>
          )}
          <InputV1
            name="txtRepeatPassword"
            inputType="number"
            headerStr="Repita la Contraseña"
            errorStr="La contraseña no es válida"
            className={
              passwordShownRepeat
                ? "inputNumericShow inputNonScroll rb16m"
                : "inputNumeric inputNonScroll rb16m"
            }
            maxLength="10"
            checkError={errorRepeatPassword}
            isRequired={true}
            onKeyPress={onKeyPress}
            onChange={onRepeatPasswordChange}
            value={repeatPassword}
          />
          {passwordShownRepeat === false ? (
            <>
              <button
                className="ptur-loginToken-show-hideBtn"
                onClick={() => showPasswordRepeat()}
              >
                <HidePassIcon color="var(--color-latex30)" />
              </button>
            </>
          ) : (
            <>
              <button
                className="ptur-loginToken-show-hideBtn"
                onClick={() => hidePasswordRepeat()}
              >
                <ShowPassIcon color="var(--color-latex30)" />
              </button>
            </>
          )}
        </div>
        <button
          className={`${
            habilitaBtn ? "bgc-primary cursor:pointer" : "bgc-disabled"
          } c-white ptur-loginToken-btn rb16m`}
          disabled={!habilitaBtn}
          onClick={() => onGenerarContraseña()}
        >
          Generar Contraseña
        </button>
      </div>
    </div>
  );
};

export default LoginToken;
